import type { IntlShape } from 'react-intl';

import type { ADFEntity } from '@atlaskit/adf-utils/types';
import type { ExtensionModule } from '@atlaskit/editor-common/extensions';

import {
	AGENT_MANAGED_EXTENSION_KEY,
	AGENT_MANAGED_EXTENSION_TYPE_DEFAULT,
	type AgentManagedExtensionAttributes,
} from '../common/agentManagedExtensionPluginType';
import { messages } from '../common/messages';
import { generateLocalId } from '../common/utils';

import { getAgentManagedExtensionIconLoader } from './icon';

/**
 * Build the ADF entity for a new agent-managed bodied extension.
 */
const buildBlockAdf = (extensionType: string): ADFEntity => {
	const localId = generateLocalId();
	const attrs: AgentManagedExtensionAttributes = {
		extensionKey: AGENT_MANAGED_EXTENSION_KEY,
		extensionType,
		parameters: {},
		layout: 'default',
		localId,
	};
	return {
		type: 'bodiedExtension',
		attrs,
		content: [
			{
				type: 'paragraph',
			},
		],
	};
};

/**
 * `quickInsert` items contributed by the agent-managed extension manifest.
 * Returns the ADF entity for a new agent-managed bodied extension; the
 * configure popup is auto-opened by the plugin's `view.update` once the
 * inserted node appears in the doc.
 */
export const getQuickInsertModules = ({
	extensionType = AGENT_MANAGED_EXTENSION_TYPE_DEFAULT,
	intl,
}: {
	extensionType?: string;
	intl: IntlShape;
}): ExtensionModule[] => {
	return [
		{
			key: 'agent-managed-block',
			title: intl.formatMessage(messages.insertTitle),
			description: intl.formatMessage(messages.insertDescription),
			keywords: ['agent', 'rovo', 'block', 'manage', 'prompt'],
			priority: 700,
			icon: getAgentManagedExtensionIconLoader('', 'small'),
			action: async (): Promise<ADFEntity> => {
				return buildBlockAdf(extensionType);
			},
		},
	];
};
